export enum NotificationType {
  NEW_COMMENT = 'new_comment',
  NEW_REFERRAL = 'new_referral',
  ACTION_REQUIRED = 'action_required',
  REFERRAL_ACCEPTED = 'referral_accepted',
}

export interface Notification {
  id: number;
  type: NotificationType;
  title: string;
  message: string;
  timestamp: Date;
  isRead: boolean;
}
